import { Button } from "../button/Button.js";
import { DEFAULT_COLORS, getColorName } from "./utils.js";
import { Swatch } from "./Swatch.js";
import { ColorPickerInput } from "./ColorInput.js";
import { Content, Portal, Root, Trigger } from "../popover/Popover.js";
import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
//#region src/color-picker/ColorPickerDropdown.tsx
const ColorPickerDropdown = ({ onClickColor, value = DEFAULT_COLORS[0], contentClassName, ...restColorInputProps }) => {
	const ariaLabel = useMemo(() => {
		let label = "Choose a color";
		if (value) {
			if (getColorName(value)) label += `, currently selected ${getColorName(value)}`;
			else label += `, currently selected custom color ${value}`;
		}
		return label;
	}, [value]);
	return /* @__PURE__ */ jsxs(Root, { children: [/* @__PURE__ */ jsx(Trigger, {
		asChild: true,
		children: /* @__PURE__ */ jsxs(Button, {
			variant: "outline",
			color: "neutral",
			className: "justify-start",
			"aria-label": ariaLabel,
			children: [/* @__PURE__ */ jsx(Swatch, { color: value }), getColorChoiceLabel(value)]
		})
	}), /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(Content, {
		sideOffset: 5,
		align: "start",
		className: twMerge("max-w-md p-4", contentClassName),
		children: /* @__PURE__ */ jsx(ColorPickerInput, {
			onClickColor,
			value,
			...restColorInputProps
		})
	}) })] });
};
const getColorChoiceLabel = (color) => {
	return color.toLowerCase() === "transparent" ? "None" : color.toUpperCase();
};
//#endregion
export { ColorPickerDropdown };
